import {componentsHelper} from './_helper'

export default [
  {
    path: '/products',
    ...componentsHelper('products/index')
  },
  {
    path: '/products/category/:category',
    ...componentsHelper('products/index')
  },
  {
    path: '/products/:id',
    ...componentsHelper('products/show')
  }
]



// WEBPACK FOOTER //
// ./client/router/products.js